import React from 'react';
import classNames from 'classnames';
import LinkList from '../ui/link-list/LinkList';
import HeaderLink from '../link/Link';
// eslint-disable-next-line
import SkipLink from '../skip-link/SkipLink';

import styles from './link-list.scss';

const TopLinks = ({ links, isBrandPromiseActive }) => (
  <LinkList
    links={links}
    Item={HeaderLink}
    className={classNames(styles.links, {
      [styles.links__bp]: isBrandPromiseActive,
    })}
    isBrandPromiseActive={isBrandPromiseActive}
  />
);

const SkipLinks = ({ links }) => (
  <LinkList links={links} Item={SkipLink} className={styles.skip} />
);

export { TopLinks, SkipLinks };
